export const GET_BACKGROUND_COLOR = "GET_BACKGROUND_COLOR";
export const SET_BACKGROUND_COLOR = "SET_BACKGROUND_COLOR";
